"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Multipass = void 0;
const crypto = __importStar(require("crypto"));
const BLOCK_SIZE = 16;
class Multipass {
    constructor(secret) {
        if (!(typeof secret == "string" && secret.length > 0))
            throw new Error("Invalid Secret");
        this.secret = secret;
        // Use the Multipass secret to derive two cryptographic keys,
        // one for encryption, one for signing
        var hash = crypto.createHash("sha256").update(secret).digest();
        this._encryptionKey = hash.slice(0, BLOCK_SIZE);
        this._signingKey = hash.slice(BLOCK_SIZE, 32);
    }
    withCustomerData(customer) {
        if (!customer) {
            throw new Error("customer data you provided is empty or invalid");
        }
        this.customer = customer;
        return this;
    }
    withDomain(domain) {
        // todo add domain validation. check if domain contains http://, if so, normalize it
        this.domain = domain;
        return this;
    }
    withRedirect(to) {
        this.redirect = to;
        return this;
    }
    url() {
        if (!this.customer) {
            throw new Error("cannot generate url. you did not provided any customer information");
        }
        if (!this.domain) {
            throw new Error("cannot generate url. you did not provided any domain information");
        }
        return `https://${this.domain}/account/login/multipass/${this.encode(this.customer)}`;
    }
    token() {
        if (!this.customer) {
            throw new Error("cannot generate url. you did not provided any customer information");
        }
        return this.encode(this.customer);
    }
    encode(obj) {
        if (!obj)
            return;
        // Store the current time in ISO8601 format.
        // The token will only be valid for a small timeframe around this timestamp.
        const payload = Object.assign({ created_at: obj.created_at ? obj.created_at : new Date().toISOString(), return_to: obj.return_to ? obj.return_to : this.redirect }, obj);
        // Serialize the customer data to JSON and encrypt it
        const cipherText = this.encrypt(JSON.stringify(payload));
        // Create a signature (message authentication code) of the ciphertext
        // and encode everything using URL-safe Base64 (RFC 4648)
        let token = Buffer.concat([cipherText, this.sign(cipherText)]).toString("base64");
        token = token
            .replace(/\+/g, "-") // Replace + with -
            .replace(/\//g, "_"); // Replace / with _
        return token;
    }
    encrypt(plaintext) {
        // Use a random IV
        const iv = crypto.randomBytes(BLOCK_SIZE);
        const cipher = crypto.createCipheriv("aes-128-cbc", this._encryptionKey, iv);
        // Use IV as first block of ciphertext
        const encrypted = Buffer.concat([
            iv,
            cipher.update(plaintext, "utf8"),
            cipher.final(),
        ]);
        return encrypted;
    }
    sign(data) {
        const signed = crypto
            .createHmac("SHA256", this._signingKey)
            .update(data)
            .digest();
        return signed;
    }
}
exports.Multipass = Multipass;
//# sourceMappingURL=index.js.map